import { render, staticRenderFns } from "./ApprovalPage.vue?vue&type=template&id=27d4be50&scoped=true&lang=pug"
import script from "./ApprovalPage.vue?vue&type=script&lang=js"
export * from "./ApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPage.vue?vue&type=style&index=0&id=27d4be50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d4be50",
  null
  
)

export default component.exports